/*
 Created by CHT 2019/10/10 16:51
 */
import BaseItem from '../BaseItem'
import {
	DATA_TYPE__STRING,
	FORM_ITEM__DIVIDINGLINE
} from "../types"

class DividingLine extends BaseItem {
	constructor() {
		super()
		this.lineShowStyle = 'solid' // 分割线name
		this.lineMainColor = '' // 分割线颜色
		this.lineTitleColor = '' // 分割标题颜色
		this.clickJumpUrl = '' // 跳转url
	}

	get title() {
		return this.fieldTitle || DividingLine._title
	}

	set title(val) {
		this.fieldTitle = val
		this.temTitle = val
	}
}

DividingLine._title = '分割线'
DividingLine.type = FORM_ITEM__DIVIDINGLINE
DividingLine.use = true
DividingLine.prototype.icon = 'iconfont icon-describe'

DividingLine.prototype.type = DividingLine.type
DividingLine.prototype.dataType = FORM_ITEM__DIVIDINGLINE
DividingLine.prototype.getConf = function() {
	const base = this.getBase()
	return {
		...base,
		lineShowStyle:this.lineShowStyle,
		lineMainColor:this.lineMainColor,
		lineTitleColor:this.lineTitleColor,
		clickJumpUrl:this.clickJumpUrl
	}
}
DividingLine.prototype.setConf = function(opts) {
	this.setBase(opts)
	if (opts.lineShowStyle) {
		this.lineShowStyle = opts.lineShowStyle
	}
	if (opts.lineMainColor) {
		this.lineMainColor = opts.lineMainColor
	}
	if (opts.lineTitleColor) {
		this.lineTitleColor = opts.lineTitleColor
	}
	if (opts.clickJumpUrl) {
		this.clickJumpUrl = opts.clickJumpUrl
	}
}
DividingLine.prototype.colorOpts = [
	'#2196F3',
	'#E91E63',
	'#FF9800',
	'#4CAF50',
	'#00BCD4',
	'#3F51B5',
	'#455A64',
	'#63B2EE',
	'#76DA91',
	'#F8CB7F',
	'#7CD6CF',
	'#9192AB',
	'#7898E1',
	'#EFA666',
	'#9987CE'
]

DividingLine.prototype.styleList = [{
	name: 'solid',
	lineColor: '#4260FA',
	textColor: '#333333',
	textRemark: '样式1',
	title: '分割线',
	sequence: 1,
	src: require('../../../assets/images/divider1.png')
}, {
	name: 'dotted',
	lineColor: '#4260FA',
	textColor: '#333333',
	textRemark: '样式2',
	title: '分割线',
	sequence: 2,
	src: require('../../../assets/images/divider2.png')
}, {
	name: 'leftThick',
	lineColor: '#D3DDE8',
	textColor: '#333333',
	textRemark: '样式3',
	title: '分割线',
	sequence: 3,
	src: require('../../../assets/images/divider3.png')
}, {
	name: 'middleThick',
	lineColor: '#96DAC4',
	textColor: '#333333',
	textRemark: '样式4',
	title: '分割线',
	sequence: 4,
	src: require('../../../assets/images/divider4.png')
}, {
	name: 'mTwoOclock',
	lineColor: '#FF9234',
	textColor: '#333333',
	textRemark: '样式5',
	title: '分割线',
	sequence: 5,
	src: require('../../../assets/images/divider5.png')
}, {
	name: 'lTwoOclock',
	lineColor: '#3F6699',
	textColor: '#3F6699',
	textRemark: '样式6',
	title: '分割线',
	sequence: 6,
	src: require('../../../assets/images/divider6.png')
}, {
	name: 'middleNull',
	lineColor: '#7EA6F4',
	textColor: '#333333',
	textRemark: '样式7',
	title: '分割线',
	sequence: 7,
	src: require('../../../assets/images/divider7.png')
}, {
	name: 'square',
	lineColor: '#D3DDE8',
	textColor: '#ffffff',
	textRemark: '样式8',
	title: '分割线',
	sequence: 8,
	src: require('../../../assets/images/divider8.png')
}, {
	name: 'rounded',
	lineColor: '#8E98F5',
	textColor: '#ffffff',
	textRemark: '样式9',
	title: '分割线',
	sequence: 9,
	src: require('../../../assets/images/divider9.png')
}, {
	name: 'leftRounded',
	lineColor: '#4260FA',
	textColor: '#ffffff',
	textRemark: '样式10',
	title: '分割线',
	sequence: 10,
	src: require('../../../assets/images/divider10.png')
}, {
	name: 'leftEdge',
	lineColor: '#4260FA',
	textColor: '#ffffff',
	textRemark: '样式11',
	title: '分割线',
	sequence: 11,
	src: require('../../../assets/images/divider11.png')
}, {
	name: 'middleEdge',
	lineColor: '#A0E4F1',
	textColor: '#ffffff',
	textRemark: '样式12',
	title: '分割线',
	sequence: 12,
	src: require('../../../assets/images/divider12.png')
}, {
	name: 'leftRound',
	lineColor: '#4260FA',
	textColor: '#333333',
	textRemark: '样式13',
	title: '分割线',
	sequence: 13,
	src: require('../../../assets/images/divider14.png')
}, {
	name: 'middleRound',
	lineColor: '#4260FA',
	textColor: '#8E98F5',
	textRemark: '样式14',
	title: '分割线',
	sequence: 14,
	src: require('../../../assets/images/divider15.png')
}, {
	name: 'bothEndsDot',
	lineColor: '#4260FA',
	textColor: '#8E98F5',
	textRemark: '样式15',
	title: '分割线',
	sequence: 15,
	src: require('../../../assets/images/divider16.png')
}]
export default DividingLine
